module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "oco2geos-co2-daygrid-v10r.thumbnails.daily.bd801c54.png";